import styled from 'styled-components/macro';
import check from 'assets/icons/check.svg';
import { Coords } from '../../../../types';

export const Wrapper = styled.div`
  position: relative;
`;

export const ItemWrapper = styled.div<{
  isClickable: boolean;
}>`
  display: flex;
  gap: 8px;
  color: #1f2939;
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};

  :hover {
    color: ${(props) => (props.isClickable ? '#3e78e9' : '#1f2939')};
  }
`;

export const MenuWrapper = styled.div<{
  coords: Coords;
  height: number;
}>`
  z-index: 99999;
  background-color: white;
  position: absolute;
  left: ${(props) => `${props.coords.left - 8}px`};
  top: ${(props) =>
    `${
      props.coords.top +
      7 -
      (props.coords.top + props.height + 7 > window.innerHeight
        ? props.height + 32
        : 0)
    }px`};
  border-radius: 8px;
  border: 1px solid #ced5de;
  padding: 4px 0;
  box-shadow: 0 2px 4px 0 rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12), 0 0 10px 6px rgba(15, 23, 40, 0.04);
`;

export const ScrollWrapper = styled.div`
  padding: 0;
  margin: 0;
  width: fit-content;
  max-height: 175px;
  overflow-y: auto;
  overscroll-behavior-y: none;

  ::-webkit-scrollbar {
    width: 12px;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-track {
    background: inherit;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e4e8ee;
    border: 4px solid #ffffff;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #9da6b4;
  }
`;

export const Footer = styled.div`
  display: flex;
  background-color: #ffffff;
  align-items: start;
  align-self: stretch;
  flex-direction: row;
  justify-content: end;
  border-top: 1px solid #d8deeb;
  padding: 8px 12px 4px 12px;
`;

export const OptionItem = styled.div`
  display: block;
`;

export const OptionWrapper = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  background-color: #ffffff;
  padding: 0 12px;
  gap: 50px;
  align-items: center;
  justify-content: space-between;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  transition: background-color 0.2s ease;

  :hover {
    background-color: ${({ $isDisabled }) =>
      $isDisabled ? 'transparent' : '#f2f5f8'};
  }
`;

export const Text = styled.div<{ $isDisabled?: boolean }>`
  width: 100%;
  padding: 10px 0;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: #1f2939;
  white-space: nowrap;
`;

export const CheckIcon = styled.img.attrs({
  src: check,
})`
  height: 16px;
  width: 16px;
`;

export const EmptyIcon = styled.div`
  height: 16px;
  width: 16px;
`;